<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import type { ITempSchemeObj } from 'src/types/TemperatureSchemeType';
	import ThermostatWizard from '../../TemperatureScheme/TempSchemeWizard/ThermostatWizard.svelte';
	import { _deepClone } from 'src/helpers/utilities';
	import { temp_scheme_prototype } from '../../TemperatureScheme/TempSchemeWizard/temp_scheme_object';
	import { location } from 'svelte-spa-router';
	import { onMount } from 'svelte';

	export let showModal = false;

	let temp_scheme_object: ITempSchemeObj = _deepClone(temp_scheme_prototype) as ITempSchemeObj;
	let thermostat_id;

	const setThermostatRoomID = () => {
		const locationSplit = $location.split('/').filter(Boolean);
		const roomID = locationSplit[1] === 'room' ? locationSplit[2] : '';

		if (roomID) {
			temp_scheme_object._meta.room = +roomID;
		}
	};

	onMount(() => {
		setThermostatRoomID();
	});
</script>

<ThermostatWizard
	bind:id={thermostat_id}
	bind:showAddEditModal={showModal}
	on:close
	{temp_scheme_object}
/>
